<i (click)="showPreviousDayTasksDialog()" class="pointer-cursor" [pTooltip]="title" tooltipPosition="top"
	class="pi pi-bell notification-bell"></i>

<p-dialog header="{{title}} ({{previousDayOrders.length}})" [(visible)]="popupVisible" [draggable]="false" [resizable]="false"
	(onHide)="reset()" [modal]="true" [closable]="true" [style]="{width: '80vw', height: '75vh'}">
	<div class="position-relative ps-1">
		<div class="action-buttons nav-item py-2 px-2">
			<button class="pn-button pn-button-tertiary move-control-button me-1" type="button" [disabled]="taskMovementService.isResetDisabled"
				(click)="reset()">Reset</button>
			<app-update-state (handleUpdateStateSuccess)="getPreviousDayData()" ></app-update-state>
		</div>
		<div class="prime-table m-2" style="height: calc(75vh - 140px);">
			<p-table #dataTable dataKey="id" [selection]="taskMovementService.selectedOptionsForTaskMove" [resizableColumns]="true"
				[value]="previousDayOrders" [columns]="visibleColumns" [rowHover]="true" 
				sortMode="multiple" [scrollable]="true"
				scrollHeight="flex" columnResizeMode="expand" [virtualScroll]="true" [virtualScrollItemSize]="35"
				[style]="{width:'100%'}" dataKey="task_id" selectionMode="multiple" [tableStyle]="{'table-layout': 'fixed'}"
				(selectionChange)="onTableSelectionChange($event)">			
				<ng-template pTemplate="loadingicon">
				<svg id="ag-loading-overlay" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
					<circle class="circle" cx="12" cy="12" r="10" stroke-width="3" stroke="#3A5487"></circle>
					<circle class="dot" cx="21.3" cy="16" r="1.48" fill="#3A5487"></circle>
				</svg>
			</ng-template>				<ng-template pTemplate="header" let-columns>
					<tr>
						<th id="checkbox-header" pResizableColumn style="width: 2rem"></th>
						<ng-container *ngFor="let column of visibleColumns">
							<th *ngIf="column.field === 'pbm_order_id'" pResizableColumn [ngStyle]="{width: column.width}"
								[id]="column.field" scope="col" [pSortableColumn]="column.field">
								{{column.label}}
								<p-sortIcon class="me-1" [field]="column.field" />

							</th>
							<th *ngIf="column.field !== 'task_state' && column.field !== 'pbm_order_id' " pResizableColumn
								[ngStyle]="{'width': column.width}" [id]="column.field" [pSortableColumn]="column.field">
								{{column.label}}<p-sortIcon [field]="column.field" />
							</th>
							<th *ngIf="column.field === 'task_state'" pResizableColumn [ngStyle]="{width: column.width}"
								[id]="column.field" scope="col" [pSortableColumn]="column.field">
								{{column.label}}
								<p-sortIcon class="me-1" [field]="column.field" />
							</th>
						</ng-container>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-rowIndex="rowIndex" let-previousDayOrders>
					<tr [pSelectableRowDisabled]="!previousDayOrders.isMovementAllowed"
						[pSelectableRow]="previousDayOrders.isMovementAllowed ? previousDayOrders : null"
						[pSelectableRowIndex]="rowIndex">
						<td>
							<ng-container *ngIf="previousDayOrders.address; else showErrorMsg">
								<p-tableCheckbox [pSelectableRow]="previousDayOrders" [value]="previousDayOrders"></p-tableCheckbox>
							</ng-container>
							<ng-template #showErrorMsg>
								<i class="pi pi-info-circle info-icon" [pTooltip]="'Not allowed'" positionStyle="fixed"></i>
							</ng-template>
						</td>
						<ng-container *ngFor="let col of visibleColumns">
							<td *ngIf="
								col.field !== 'pbm_order_id' &&
                    			col.field !== 'task_state' &&
								col.field !== 'manager_instruction' && 
								col.field !== 'address' && col.field !== 'goods_count' && col.field !== 'item_count'"
							class="wrapRowData" pTooltip="{{previousDayOrders[col.field]}}" positionStyle="fixed"
							tooltipPosition="bottom">
								{{previousDayOrders[col.field]}}
							</td>
							<td *ngIf="col.field === 'pbm_order_id'">
								<div class="d-flex align-items-center">
									<a href="void:()" class="anchor"
									 [style.--orderColor]="previousDayOrders?.pbm_order_id | orderIdColor"
										(click)="editPickupOrder(previousDayOrders); $event.stopPropagation();">{{previousDayOrders.pbm_order_id}}</a>
								</div>
							</td>
							<td *ngIf="col.field === 'manager_instruction'" class="wrapRowData"
							[pTooltip]="previousDayOrders.manager_instruction" tooltipPosition="bottom" positionStyle="fixed">
								<button (click)="handleEditManagerNotesAddress(previousDayOrders,'manager'); $event.stopPropagation()"
									class="pi pi-pencil edit-icon"></button>
								{{previousDayOrders.manager_instruction}}
							</td>
							<td *ngIf="col.field === 'item_count'" [ngClass]="{'pointer-cursor': previousDayOrders.item_count > 0}"
								onkeydown="openItemDialog(previousDayOrders, 'items'); $event.stopPropagation();" (click)="openItemDialog(previousDayOrders, 'items'); $event.stopPropagation();">
								<a class="anchor" *ngIf="previousDayOrders.item_count > 0">{{previousDayOrders.item_count}}</a>
								<span *ngIf="previousDayOrders.item_count === 0">{{previousDayOrders.item_count}}</span>
                			</td>
							<td  *ngIf="col.field === 'goods_count'"  [ngClass]="{'pointer-cursor': previousDayOrders.goods_count > 0}"
								[pTooltip]="previousDayOrders.good_types" tooltipPosition="bottom" positionStyle="fixed"
								onkeydown="openItemDialog(previousDayOrders, 'goods'); $event.stopPropagation();" (click)="openItemDialog(previousDayOrders, 'goods'); $event.stopPropagation();">
								<a class="anchor" *ngIf="previousDayOrders.goods_count > 0">{{previousDayOrders.goods_count}}</a>
								<span *ngIf="previousDayOrders.goods_count === 0">{{previousDayOrders.goods_count}}</span>
							</td>
							<td *ngIf="col.field === 'address'" class="wrapRowData"
							[pTooltip]="previousDayOrders.address" tooltipPosition="bottom" positionStyle="fixed">
								<button (click)="handleEditManagerNotesAddress(previousDayOrders,'address'); $event.stopPropagation()"
									class="pi pi-pencil edit-icon"></button>
								{{previousDayOrders.address}}
							</td>
							<td *ngIf="col.field === 'task_state'"><span
									[ngStyle]="previousDayOrders.task_state | TaskState">{{previousDayOrders.task_state}}</span></td>
						</ng-container>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="15">
							<div class="text-center no-record-label">
								No Records found.
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</p-dialog>

@if(DialogType === 'PreviousDayPopup' &&  getShowPopup) {
	<p-dialog header="{{ DialogHeader }}" [(visible)]="getShowPopup" [modal]="true"
	[breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{width: DialogHeader === 'Update Address' ? '70vw' : '40vw',height:
           DialogHeader === 'Update Address' ? '73vh' : 'auto'}" [draggable]="false" [resizable]="false" >

		@if (DialogHeader === 'Update Address') {
			<app-update-address #updateStateAddressNotification [taskId]="getUpdateTaskID" (onCancel)="closeDialog($event)" (closeDialog)="closeDialog($event); getPreviousDayData()">
			</app-update-address>
			<ng-template #footer>
				<ng-container *ngTemplateOutlet="updateStateAddressNotification.updateAddressFooter"></ng-container>
			</ng-template>
		}
		@else if (DialogHeader === 'Update Manager Notes') {
			<app-update-manager-notes #managerNotesNotificationFooter [task]="getUpdateTask" (closeDialog)="closeDialog($event); getPreviousDayData()">
			</app-update-manager-notes>
			<ng-template #footer>
				<ng-container *ngTemplateOutlet="managerNotesNotificationFooter.managerNotesFooter"></ng-container>
			</ng-template>
		}
	</p-dialog>
}


<p-dialog header="{{header}}" [(visible)]="displayItemDialog" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '80vw' }" [draggable]="false"
    [resizable]="false">
    <app-item-details *ngIf="displayItemDialog" [additionalData]="additionalData"></app-item-details>
</p-dialog>
